module.exports = __webpack_public_path__ + "img/service.99d406b4.png";